window.theme = window.theme || {};

window.theme.sizes = {
  small: 480,
  medium: 768,
  large: 990,
  widescreen: 1400,
};

window.theme.keyboardKeys = {
  TAB: 9,
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
  LEFTARROW: 37,
  RIGHTARROW: 39,
};
